import React from 'react'
import { Left } from './left';
import { Right } from './right';
import { NewProject } from './newProject';
import { Breadcrumbs } from './breadcrumbs';
import { Center } from './center';
import Navbar from '../../../@shared/navigations/default';

const ProfileFeedPage = () => {
    const [setUserEditDrawer] = React.useState(false);
    const close = (status) => setUserEditDrawer(status)
   
    return  (
      <div>
        <Navbar />
        <NewProject
          status={false} 
          close={close}
        />
        <Breadcrumbs />
        <div className="container1">
           
           <div>
            <Left />
            <Center />
            <Right/>           
            </div>
        </div>
      </div>
    )
}
  
export default ProfileFeedPage
